function hexToRgba(hex, alpha) {
    const raw = String(hex ?? "").replace("#", "").trim()
    if (raw.length !== 6) {
        return `rgba(0, 0, 0, ${alpha})`
    }
    const r = parseInt(raw.slice(0, 2), 16)
    const g = parseInt(raw.slice(2, 4), 16)
    const b = parseInt(raw.slice(4, 6), 16)
    return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

/**
 * @typedef {(
 *   | "new"
 *   | "open"
 *   | "closed"
 *   | "shipped"
 *   | "received"
 * )} ManifestStatusKey
 */

/** @type {Record<ManifestStatusKey, { backgroundColor: string, color: string, borderColor: string }>} */
export const MANIFEST_STATUS_BADGE_STYLE_BY_STATUS = {
    // v1 lodge palette: open = green, closed = red, shipped = blue, received = purple.
    new: {
        color: "#9e2424",
        borderColor: "#9e2424",
        backgroundColor: hexToRgba("#d93f3f", 0.22),
    },
    open: {
        color: "#1a6b32",
        borderColor: "#1a6b32",
        backgroundColor: hexToRgba("#34b356", 0.28),
    },
    closed: {
        color: "#9e2424",
        borderColor: "#9e2424",
        backgroundColor: hexToRgba("#d93f3f", 0.22),
    },
    shipped: {
        color: "#1a5f78",
        borderColor: "#1a5f78",
        backgroundColor: hexToRgba("#3491b3", 0.28),
    },
    received: {
        color: "#5a1f75",
        borderColor: "#5a1f75",
        backgroundColor: hexToRgba("#8d34b3", 0.24),
    },
}

/**
 * Accepts either raw API status values or formatted display labels.
 * @param {string | null | undefined} status
 * @returns {ManifestStatusKey | null}
 */
export function normalizeManifestStatusKey(status) {
    const s = String(status ?? "").trim().toLowerCase()
    if (!s) {
        return null
    }

    // Raw API values
    if (s === "new") return "new"
    if (s === "open") return "open"
    if (s === "closed") return "closed"
    if (s === "shipped") return "shipped"
    if (s === "received") return "received"

    // Formatted labels
    if (s === "open") return "open"
    if (s === "closed") return "closed"
    if (s === "shipped") return "shipped"
    if (s === "received") return "received"
    // Some UIs format shipped as "Transferring" (mirrors order badge mapping).
    if (s === "transferring") return "shipped"

    return null
}

/**
 * @param {string | null | undefined} status
 * @returns {{ backgroundColor?: string, color?: string, borderColor?: string }}
 */
export function getManifestStatusBadgeStyle(status) {
    const key = normalizeManifestStatusKey(status)
    if (!key) {
        return {}
    }
    return MANIFEST_STATUS_BADGE_STYLE_BY_STATUS[key] ?? {}
}

